import PathObject from "../objects/path"
import Form from "./base"
import { parisRoundPath } from "@/signomatic/util/shapes"

export default class ParisForm extends Form {
  protected path(width: number) {
    return new PathObject(this.commands(width), this.defaultParams)
  }

  protected commands(width: number) {
    return parisRoundPath(width)
  }
}
